/**
 * This number helps avoid unintended bugs when parsing numbers that we gather from user input:
 * Number.parseInt('10asdasdasd') === 10 in Javascript. We don't want that. Otherwise you could
 * keep appending random stuff at the end of urls, like schoolhouse.world/admin/user/10asdasdasd
 * and it'll be treated as valid. We only ever want to respond to the actual valid query.
 */
export default function parseQueryNumber({
  value,
  defaultValue,
}: {
  value: string | string[] | number | undefined
  defaultValue: number
}): number {
  const parsed = Number.parseInt(`${value}`, 10)
  if (Number.isNaN(parsed) || parsed.toString() !== `${value}`) {
    return defaultValue
  }
  return parsed
}
